const {HEADER$, SECONDARY_HEADER$, MENU_TRIGGER$, DROP_MENU$} = upi.selector;

class DesktopMenu {

    _menuHoverTimeoutId = null;
    _menuLeaveTimeoutId = null;
    _frozenMenus = [];

    constructor () {
        console.log( '@init [DesktopMenu]' );

        this.locale = document.documentElement.getAttribute( 'lang' );
        this.siteHeader = $( HEADER$ );
        this.countrySelect = $( '#nav--country-select' );
        this.navWrapper = $( '#nav-lvl-primary' );
        // note -> Hiding the secondary education menu until we have more items in the future to add
        this.secondaryHeaders = $( SECONDARY_HEADER$ );
        this.revealSecondary = $( SECONDARY_HEADER$ + `[data-menu-static]` );
        this.activatePrimaryMenu( this.revealSecondary );
        // toggle collapsable header
        this.initEvents();
    }

    initEvents () {
        this.countrySelect
            .on( 'mouseenter', MENU_TRIGGER$, this.onDropMenuEnter )
            .on( 'mouseleave', MENU_TRIGGER$, this.onDropMenuLeave );
        this.navWrapper
            .on( 'mouseenter', MENU_TRIGGER$, this.onPrimaryMenuEnter )
            .on( 'mouseleave', MENU_TRIGGER$, this.onPrimaryMenuLeave );
        this.secondaryHeaders
            .on( 'mouseenter', () => {
                clearTimeout( this._menuLeaveTimeoutId );
            } )
            .on( 'mouseleave', ( e ) => {
                this._menuLeaveTimeoutId = setTimeout( () => {
                    this.deactivatePrimaryMenu( $( e.currentTarget ) );
                    this.activatePrimaryMenu( this.revealSecondary );
                }, 90 );
            } );

        // detect click events outside a menu to thaw/deactivate all menus
        $( document ).on( 'click touchstart', e => {
            if ( !this.getClosestMenu( e.target ).length ) {
                this.thawAllMenus();
            }
        } );

        // note - bypass this feature for the US site
        if ( this.locale && this.locale.toLowerCase() !== 'en-us' ) {
            this.siteHeader.find( '.nav--country-select' ).addClass( 'hidden' );

            if ( this.revealSecondary.length ) {
                this.makeSticky( this.revealSecondary, this.revealSecondary );
            }
            else {
                this.makeSticky( this.siteHeader, this.siteHeader );
            }
        }

        $( '.nav-drop-menu' ).on( 'touchstart', e => e.stopPropagation() );
    }

    makeSticky = ( el, targetEl ) => {
        const pageContainer = $( window );
        const headerSecondary = $( '.header-secondary' );
        const elOriginTop = targetEl.offset().top;

        pageContainer.scroll( function () {
            if ( pageContainer.scrollTop() > elOriginTop ) {
                $( el ).css( 'position', 'fixed' ).css( 'top', '0' ).css( 'width', '100%' ).css( 'z-index', '200' );
            }
            else {
                $( el ).css( 'position', 'relative' );
                headerSecondary.css( 'position', 'absolute' ).css( 'top', '90px' );
            }
        } );
    };

    onDropMenuEnter = e => {
        this._menuHoverTimeoutId = setTimeout( () => this.activateMenu( $( e.currentTarget ) ), 90 );
    };

    onDropMenuLeave = e => {
        if ( this._frozenMenus.length ) {
            return;
        }

        clearTimeout( this._menuHoverTimeoutId );
        this.deactivateMenu( $( e.currentTarget ) );
    };

    onPrimaryMenuEnter = e => {
        const target = e.currentTarget;
        const menuId = target.dataset.menuId;
        const activeMenu = $( SECONDARY_HEADER$ + `[data-menu-id=${menuId}]` );

        this._menuHoverTimeoutId = setTimeout( () => {
            this.secondaryHeaders.each( ( i, el ) => {
                this.deactivatePrimaryMenu( $( el ) );
            } );
            this.activatePrimaryMenu( activeMenu );
        }, 90 );
    };

    onPrimaryMenuLeave = e => {
        if ( this._frozenMenus.length ) {
            return;
        }

        const target = e.currentTarget;
        const menuId = target.dataset.menuId;
        const activeMenu = $( SECONDARY_HEADER$ + `[data-menu-id=${menuId}]` );

        this._menuLeaveTimeoutId = setTimeout( () => {
            this.deactivatePrimaryMenu( activeMenu );
            this.activatePrimaryMenu( this.revealSecondary );
        }, 90 );

        clearTimeout( this._menuHoverTimeoutId );
    };

    onFocusin = e => {
        const menu = this.getClosestMenu( e.target );
        this.freezeMenu( menu );
    };

    toggleMenu = e => {
        const el = $( e.currentTarget );

        (el.data( 'isActive' ))
            ? this.deactivateMenu( el )
            : this.activateMenu( el );
    };

    getClosestMenu = target => $( target ).closest( MENU_TRIGGER$ );

    freezeMenu = ( menu ) => {
        this._frozenMenus = this._frozenMenus.concat( [menu] );
    };

    thawAllMenus = () => {
        this._frozenMenus.forEach( menu => {
            menu.find( 'input' ).blur();
            this.deactivateMenu( menu );
        } );

        this._frozenMenus = [];
    };

    activateMenu = ( el ) => {
        if ( el.data( 'isActive' ) ) {
            return;
        }
        this.thawAllMenus();
        el.data( 'isActive', true );
        el.find( DROP_MENU$ ).removeClass( 'hidden' );
    };

    deactivateMenu = el => {
        el.data( 'isActive', false );
        el.find( DROP_MENU$ ).addClass( 'hidden' );
    };

    activatePrimaryMenu = ( el ) => {
        el.data( 'isActive', true );
        el.removeClass( 'hidden' );
        const menuId = el.attr( `data-menu-id` );
        el.parent().find( `[data-menu-id=${menuId}]` ).addClass( 'flipChevron' );

    };

    deactivatePrimaryMenu = el => {
        el.data( 'isActive', false );
        el.addClass( 'hidden' );
        const menuId = el.attr( `data-menu-id` );
        el.parent().find( `[data-menu-id=${menuId}]` ).removeClass( 'flipChevron' );
    };
}

export default DesktopMenu;
